// Translations
import form from '../sections/form/translations/de'

// Translation: Terms of service > Landing (German)
export default Object.freeze({
	sections: { form }
})
